// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/bg/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.area-master {
    background-color: #e9f2f7e3;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
  
  .area-master .div {
    background-color: #e9f2f7e3;
    border: 1px none;
    height: 1080px;
    overflow: hidden;
    position: relative;
    width: 1920px;
  }
  
  .area-master .overlap {
    background-color: #ffffff;
    border: 1px solid;
    border-color: #d9d9d9;
    height: 102px;
    left: -1px;
    position: absolute;
    top: -1px;
    width: 1922px;
  }
  
  .area-master .header-DATA {
    color: #000000;
    font-family: "Red Hat Display-Bold", Helvetica;
    font-size: 24px;
    font-weight: 700;
    left: 111px;
    letter-spacing: 0.24px;
    line-height: normal;
    position: absolute;
    top: 33px;
  }
  
  .area-master .logo-SIVINA {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    height: 60px;
    left: 31px;
    position: absolute;
    top: 20px;
    width: 60px;
  }
  
  .area-master .action-project {
    color: #000000;
    font-family: "Montserrat-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 1329px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 35px;
  }
  
  .area-master .action-dashboard {
    color: #000000;
    font-family: "Montserrat-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 1650px;
    letter-spacing: 0.48px;
    line-height: normal;
    position: absolute;
    top: 35px;
  }
  
  .area-master .profile-icon {
    background-color: #49bc92;
    border-radius: 25px;
    height: 50px;
    left: 1840px;
    position: absolute;
    top: 25px;
    width: 50px;
  }
  
  .area-master .s {
    height: 18px;
    left: 19px;
    position: absolute;
    top: 16px;
    width: 13px;
  }
  
  .area-master .caption-menampilkan {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 813px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 1030px;
    white-space: nowrap;
  }
  
  .area-master .page {
    height: 35px;
    left: 1640px;
    position: absolute;
    top: 1027px;
    width: 257px;
  }
  
  .area-master .text-wrapper {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 45px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-2 {
    color: #000000;
    font-family: "Roboto-SemiBold", Helvetica;
    font-size: 24px;
    font-weight: 600;
    left: 0;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .area-master .button-next {
    height: 35px;
    left: 169px;
    position: absolute;
    top: 0;
    width: 37px;
  }
  
  .area-master .overlap-group {
    background-color: #069dae;
    border-radius: 5px;
    height: 35px;
    position: relative;
    width: 35px;
  }
  
  .area-master .text-wrapper-3 {
    color: #ffffff;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-4 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 87px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 4px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-5 {
    color: #000000;
    font-family: "Roboto-Light", Helvetica;
    font-size: 24px;
    font-weight: 300;
    left: 135px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 3px;
    white-space: nowrap;
  }
  
  .area-master .button-end {
    height: 35px;
    left: 214px;
    position: absolute;
    top: 0;
    width: 37px;
  }
  
  .area-master .text-wrapper-6 {
    color: #ffffff;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 24px;
    font-weight: 400;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 2px;
    white-space: nowrap;
  }
  
  .area-master .vector-stroke {
    height: 6px;
    left: 13px;
    position: absolute;
    top: 19px;
    width: 10px;
  }
  
  .area-master .button-add-new {
    height: 40px;
    left: 1670px;
    position: absolute;
    top: 115px;
    width: 222px;
  }
  
  .area-master .div-wrapper {
    background-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 220px;
  }
  
  .area-master .text-wrapper-7 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 40px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  
  .area-master .overlap-wrapper {
    height: 40px;
    left: 1445px;
    position: absolute;
    top: 115px;
    width: 222px;
  }
  
  .area-master .text-wrapper-8 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 23px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  
  .area-master .overlap-group-wrapper {
    height: 40px;
    left: 1220px;
    position: absolute;
    top: 115px;
    width: 222px;
  }
  
  .area-master .text-wrapper-9 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 54px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 8px;
    white-space: nowrap;
  }
  
  .area-master .action-area-store {
    height: 40px;
    left: 499px;
    position: absolute;
    top: 115px;
    width: 323px;
  }
  
  .area-master .overlap-2 {
    background-color: #ffffff;
    border: 3px solid;
    border-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 321px;
  }
  
  .area-master .polygon {
    height: 13px;
    left: 291px;
    position: absolute;
    top: 10px;
    width: 15px;
  }
  
  .area-master .text-wrapper-10 {
    color: #9f9696;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 20px;
    font-weight: 500;
    left: 11px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    top: 5px;
    white-space: nowrap;
  }
  
  .area-master .action-search {
    height: 40px;
    left: 32px;
    position: absolute;
    top: 115px;
    width: 464px;
  }
  
  .area-master .overlap-3 {
    background-color: #ffffff;
    border: 3px solid;
    border-color: #069dae;
    border-radius: 5px;
    height: 40px;
    position: relative;
    width: 462px;
  }
  
  .area-master .union {
    height: 17px;
    left: 428px;
    position: absolute;
    top: 8px;
    width: 17px;
  }
  
  .area-master .overlap-4 {
    height: 840px;
    left: 31px;
    position: absolute;
    top: 170px;
    width: 1857px;
  }
  
  .area-master .table {
    height: 840px;
    left: 0;
    position: absolute;
    top: 0;
    width: 1857px;
  }
  
  .area-master .baris-isi {
    height: 765px;
    left: 0;
    overflow: hidden;
    overflow-y: scroll;
    position: absolute;
    top: 75px;
    width: 1857px;
  }
  
  .area-master .overlap-5 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 0;
    width: 131px;
  }
  
  .area-master .text-wrapper-11 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 59px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .overlap-6 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 0;
    width: 220px;
  }
  
  .area-master .text-wrapper-12 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 54px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .overlap-7 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 0;
    width: 221px;
  }
  
  .area-master .text-wrapper-13 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 66px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .overlap-8 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 0;
    width: 182px;
  }
  
  .area-master .text-wrapper-14 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 44px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .rectangle {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 0;
    width: 180px;
  }
  
  .area-master .overlap-9 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 0;
    width: 312px;
  }
  
  .area-master .text-wrapper-15 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 80px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .overlap-10 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 0;
    width: 332px;
  }
  
  .area-master .text-wrapper-16 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 93px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .overlap-11 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .area-master .text-wrapper-17 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 57px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .overlap-12 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 55px;
    width: 131px;
  }
  
  .area-master .overlap-13 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 55px;
    width: 220px;
  }
  
  .area-master .overlap-14 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 55px;
    width: 221px;
  }
  
  .area-master .overlap-group-2 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 55px;
    width: 182px;
  }
  
  .area-master .rectangle-2 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 55px;
    width: 180px;
  }
  
  .area-master .overlap-15 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 55px;
    width: 312px;
  }
  
  .area-master .overlap-16 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 55px;
    width: 332px;
  }
  
  .area-master .text-wrapper-18 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 130px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .overlap-17 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 55px;
    width: 240px;
  }
  
  .area-master .overlap-18 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 110px;
    width: 131px;
  }
  
  .area-master .overlap-19 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 110px;
    width: 220px;
  }
  
  .area-master .overlap-20 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 110px;
    width: 221px;
  }
  
  .area-master .overlap-21 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 110px;
    width: 182px;
  }
  
  .area-master .rectangle-3 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 110px;
    width: 180px;
  }
  
  .area-master .overlap-22 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 110px;
    width: 312px;
  }
  
  .area-master .overlap-23 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 110px;
    width: 332px;
  }
  
  .area-master .text-wrapper-19 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 83px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .overlap-24 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 110px;
    width: 240px;
  }
  
  .area-master .overlap-25 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 165px;
    width: 131px;
  }
  
  .area-master .overlap-26 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 220px;
    width: 131px;
  }
  
  .area-master .rectangle-4 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 275px;
    width: 131px;
  }
  
  .area-master .rectangle-5 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 330px;
    width: 131px;
  }
  
  .area-master .rectangle-6 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 385px;
    width: 131px;
  }
  
  .area-master .rectangle-7 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 440px;
    width: 131px;
  }
  
  .area-master .rectangle-8 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 495px;
    width: 131px;
  }
  
  .area-master .rectangle-9 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 550px;
    width: 131px;
  }
  
  .area-master .rectangle-10 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 605px;
    width: 131px;
  }
  
  .area-master .rectangle-11 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 660px;
    width: 131px;
  }
  
  .area-master .rectangle-12 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 715px;
    width: 131px;
  }
  
  .area-master .rectangle-13 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 770px;
    width: 131px;
  }
  
  .area-master .overlap-27 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 165px;
    width: 220px;
  }
  
  .area-master .overlap-28 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 220px;
    width: 220px;
  }
  
  .area-master .rectangle-14 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 275px;
    width: 220px;
  }
  
  .area-master .rectangle-15 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 330px;
    width: 220px;
  }
  
  .area-master .rectangle-16 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 385px;
    width: 220px;
  }
  
  .area-master .rectangle-17 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 440px;
    width: 220px;
  }
  
  .area-master .rectangle-18 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 495px;
    width: 220px;
  }
  
  .area-master .rectangle-19 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 550px;
    width: 220px;
  }
  
  .area-master .rectangle-20 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 605px;
    width: 220px;
  }
  
  .area-master .rectangle-21 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 660px;
    width: 220px;
  }
  
  .area-master .rectangle-22 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 715px;
    width: 220px;
  }
  
  .area-master .rectangle-23 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 770px;
    width: 220px;
  }
  
  .area-master .overlap-29 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 165px;
    width: 221px;
  }
  
  .area-master .overlap-30 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 220px;
    width: 221px;
  }
  
  .area-master .rectangle-24 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 275px;
    width: 221px;
  }
  
  .area-master .rectangle-25 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 330px;
    width: 221px;
  }
  
  .area-master .rectangle-26 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 385px;
    width: 221px;
  }
  
  .area-master .rectangle-27 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 440px;
    width: 221px;
  }
  
  .area-master .rectangle-28 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 495px;
    width: 221px;
  }
  
  .area-master .rectangle-29 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 550px;
    width: 221px;
  }
  
  .area-master .rectangle-30 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 605px;
    width: 221px;
  }
  
  .area-master .rectangle-31 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 660px;
    width: 221px;
  }
  
  .area-master .rectangle-32 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 715px;
    width: 221px;
  }
  
  .area-master .rectangle-33 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 770px;
    width: 221px;
  }
  
  .area-master .overlap-31 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 165px;
    width: 182px;
  }
  
  .area-master .overlap-32 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 220px;
    width: 182px;
  }
  
  .area-master .rectangle-34 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 275px;
    width: 182px;
  }
  
  .area-master .rectangle-35 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 330px;
    width: 182px;
  }
  
  .area-master .rectangle-36 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 385px;
    width: 182px;
  }
  
  .area-master .rectangle-37 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 440px;
    width: 182px;
  }
  
  .area-master .rectangle-38 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 495px;
    width: 182px;
  }
  
  .area-master .rectangle-39 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 550px;
    width: 182px;
  }
  
  .area-master .rectangle-40 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 605px;
    width: 182px;
  }
  
  .area-master .rectangle-41 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 660px;
    width: 182px;
  }
  
  .area-master .rectangle-42 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 715px;
    width: 182px;
  }
  
  .area-master .rectangle-43 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 770px;
    width: 182px;
  }
  
  .area-master .rectangle-44 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 165px;
    width: 180px;
  }
  
  .area-master .rectangle-45 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 220px;
    width: 180px;
  }
  
  .area-master .rectangle-46 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 275px;
    width: 180px;
  }
  
  .area-master .rectangle-47 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 330px;
    width: 180px;
  }
  
  .area-master .rectangle-48 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 385px;
    width: 180px;
  }
  
  .area-master .rectangle-49 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 440px;
    width: 180px;
  }
  
  .area-master .rectangle-50 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 495px;
    width: 180px;
  }
  
  .area-master .rectangle-51 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 550px;
    width: 180px;
  }
  
  .area-master .rectangle-52 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 605px;
    width: 180px;
  }
  
  .area-master .rectangle-53 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 660px;
    width: 180px;
  }
  
  .area-master .rectangle-54 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 715px;
    width: 180px;
  }
  
  .area-master .rectangle-55 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 770px;
    width: 180px;
  }
  
  .area-master .overlap-33 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 165px;
    width: 312px;
  }
  
  .area-master .overlap-34 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 220px;
    width: 312px;
  }
  
  .area-master .text-wrapper-20 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 70px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 11px;
    white-space: nowrap;
  }
  
  .area-master .rectangle-56 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 275px;
    width: 312px;
  }
  
  .area-master .rectangle-57 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 330px;
    width: 312px;
  }
  
  .area-master .rectangle-58 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 385px;
    width: 312px;
  }
  
  .area-master .rectangle-59 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 440px;
    width: 312px;
  }
  
  .area-master .rectangle-60 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 495px;
    width: 312px;
  }
  
  .area-master .rectangle-61 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 550px;
    width: 312px;
  }
  
  .area-master .rectangle-62 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 605px;
    width: 312px;
  }
  
  .area-master .rectangle-63 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 660px;
    width: 312px;
  }
  
  .area-master .rectangle-64 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 715px;
    width: 312px;
  }
  
  .area-master .rectangle-65 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 770px;
    width: 312px;
  }
  
  .area-master .overlap-35 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 165px;
    width: 332px;
  }
  
  .area-master .overlap-36 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 220px;
    width: 332px;
  }
  
  .area-master .text-wrapper-21 {
    color: #000000;
    font-family: "Roboto-Regular", Helvetica;
    font-size: 22px;
    font-weight: 400;
    left: 130px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 16px;
    white-space: nowrap;
  }
  
  .area-master .rectangle-66 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 275px;
    width: 332px;
  }
  
  .area-master .rectangle-67 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 330px;
    width: 332px;
  }
  
  .area-master .rectangle-68 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 385px;
    width: 332px;
  }
  
  .area-master .rectangle-69 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 440px;
    width: 332px;
  }
  
  .area-master .rectangle-70 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 495px;
    width: 332px;
  }
  
  .area-master .rectangle-71 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 550px;
    width: 332px;
  }
  
  .area-master .rectangle-72 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 605px;
    width: 332px;
  }
  
  .area-master .rectangle-73 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 660px;
    width: 332px;
  }
  
  .area-master .rectangle-74 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 715px;
    width: 332px;
  }
  
  .area-master .rectangle-75 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 770px;
    width: 332px;
  }
  
  .area-master .overlap-37 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 165px;
    width: 240px;
  }
  
  .area-master .overlap-38 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 220px;
    width: 240px;
  }
  
  .area-master .rectangle-76 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 275px;
    width: 240px;
  }
  
  .area-master .rectangle-77 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 330px;
    width: 240px;
  }
  
  .area-master .rectangle-78 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 385px;
    width: 240px;
  }
  
  .area-master .rectangle-79 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 440px;
    width: 240px;
  }
  
  .area-master .rectangle-80 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 495px;
    width: 240px;
  }
  
  .area-master .rectangle-81 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 550px;
    width: 240px;
  }
  
  .area-master .rectangle-82 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 605px;
    width: 240px;
  }
  
  .area-master .rectangle-83 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 660px;
    width: 240px;
  }
  
  .area-master .rectangle-84 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 715px;
    width: 240px;
  }
  
  .area-master .rectangle-85 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 770px;
    width: 240px;
  }
  
  .area-master .rectangle-86 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 825px;
    width: 131px;
  }
  
  .area-master .rectangle-87 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 825px;
    width: 220px;
  }
  
  .area-master .rectangle-88 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 825px;
    width: 221px;
  }
  
  .area-master .rectangle-89 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 825px;
    width: 182px;
  }
  
  .area-master .rectangle-90 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 825px;
    width: 180px;
  }
  
  .area-master .rectangle-91 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 825px;
    width: 312px;
  }
  
  .area-master .rectangle-92 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 825px;
    width: 332px;
  }
  
  .area-master .rectangle-93 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 825px;
    width: 240px;
  }
  
  .area-master .rectangle-94 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 880px;
    width: 131px;
  }
  
  .area-master .rectangle-95 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 935px;
    width: 131px;
  }
  
  .area-master .rectangle-96 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 990px;
    width: 131px;
  }
  
  .area-master .rectangle-97 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1045px;
    width: 131px;
  }
  
  .area-master .rectangle-98 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1100px;
    width: 131px;
  }
  
  .area-master .rectangle-99 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1155px;
    width: 131px;
  }
  
  .area-master .rectangle-100 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1210px;
    width: 131px;
  }
  
  .area-master .rectangle-101 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1265px;
    width: 131px;
  }
  
  .area-master .rectangle-102 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 0;
    position: absolute;
    top: 1320px;
    width: 131px;
  }
  
  .area-master .rectangle-103 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 880px;
    width: 220px;
  }
  
  .area-master .rectangle-104 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 935px;
    width: 220px;
  }
  
  .area-master .rectangle-105 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 990px;
    width: 220px;
  }
  
  .area-master .rectangle-106 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1045px;
    width: 220px;
  }
  
  .area-master .rectangle-107 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1100px;
    width: 220px;
  }
  
  .area-master .rectangle-108 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1155px;
    width: 220px;
  }
  
  .area-master .rectangle-109 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1210px;
    width: 220px;
  }
  
  .area-master .rectangle-110 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1265px;
    width: 220px;
  }
  
  .area-master .rectangle-111 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 136px;
    position: absolute;
    top: 1320px;
    width: 220px;
  }
  
  .area-master .rectangle-112 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 880px;
    width: 221px;
  }
  
  .area-master .rectangle-113 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 935px;
    width: 221px;
  }
  
  .area-master .rectangle-114 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 990px;
    width: 221px;
  }
  
  .area-master .rectangle-115 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1045px;
    width: 221px;
  }
  
  .area-master .rectangle-116 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1100px;
    width: 221px;
  }
  
  .area-master .rectangle-117 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1155px;
    width: 221px;
  }
  
  .area-master .rectangle-118 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1210px;
    width: 221px;
  }
  
  .area-master .rectangle-119 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1265px;
    width: 221px;
  }
  
  .area-master .rectangle-120 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 793px;
    position: absolute;
    top: 1320px;
    width: 221px;
  }
  
  .area-master .rectangle-121 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 880px;
    width: 182px;
  }
  
  .area-master .rectangle-122 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 935px;
    width: 182px;
  }
  
  .area-master .rectangle-123 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 990px;
    width: 182px;
  }
  
  .area-master .rectangle-124 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1045px;
    width: 182px;
  }
  
  .area-master .rectangle-125 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1100px;
    width: 182px;
  }
  
  .area-master .rectangle-126 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1155px;
    width: 182px;
  }
  
  .area-master .rectangle-127 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1210px;
    width: 182px;
  }
  
  .area-master .rectangle-128 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1265px;
    width: 182px;
  }
  
  .area-master .rectangle-129 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 606px;
    position: absolute;
    top: 1320px;
    width: 182px;
  }
  
  .area-master .rectangle-130 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 880px;
    width: 180px;
  }
  
  .area-master .rectangle-131 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 935px;
    width: 180px;
  }
  
  .area-master .rectangle-132 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 990px;
    width: 180px;
  }
  
  .area-master .rectangle-133 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1045px;
    width: 180px;
  }
  
  .area-master .rectangle-134 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1100px;
    width: 180px;
  }
  
  .area-master .rectangle-135 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1155px;
    width: 180px;
  }
  
  .area-master .rectangle-136 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1210px;
    width: 180px;
  }
  
  .area-master .rectangle-137 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1265px;
    width: 180px;
  }
  
  .area-master .rectangle-138 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1677px;
    position: absolute;
    top: 1320px;
    width: 180px;
  }
  
  .area-master .rectangle-139 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 880px;
    width: 312px;
  }
  
  .area-master .rectangle-140 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 935px;
    width: 312px;
  }
  
  .area-master .rectangle-141 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 990px;
    width: 312px;
  }
  
  .area-master .rectangle-142 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1045px;
    width: 312px;
  }
  
  .area-master .rectangle-143 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1100px;
    width: 312px;
  }
  
  .area-master .rectangle-144 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1155px;
    width: 312px;
  }
  
  .area-master .rectangle-145 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1210px;
    width: 312px;
  }
  
  .area-master .rectangle-146 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1265px;
    width: 312px;
  }
  
  .area-master .rectangle-147 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1023px;
    position: absolute;
    top: 1320px;
    width: 312px;
  }
  
  .area-master .rectangle-148 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 880px;
    width: 332px;
  }
  
  .area-master .rectangle-149 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 935px;
    width: 332px;
  }
  
  .area-master .rectangle-150 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 990px;
    width: 332px;
  }
  
  .area-master .rectangle-151 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 1045px;
    width: 332px;
  }
  
  .area-master .rectangle-152 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 1100px;
    width: 332px;
  }
  
  .area-master .rectangle-153 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 1155px;
    width: 332px;
  }
  
  .area-master .rectangle-154 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 1210px;
    width: 332px;
  }
  
  .area-master .rectangle-155 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 1265px;
    width: 332px;
  }
  
  .area-master .rectangle-156 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 1340px;
    position: absolute;
    top: 1320px;
    width: 332px;
  }
  
  .area-master .rectangle-157 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 880px;
    width: 240px;
  }
  
  .area-master .rectangle-158 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 935px;
    width: 240px;
  }
  
  .area-master .rectangle-159 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 990px;
    width: 240px;
  }
  
  .area-master .rectangle-160 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1045px;
    width: 240px;
  }
  
  .area-master .rectangle-161 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1100px;
    width: 240px;
  }
  
  .area-master .rectangle-162 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1155px;
    width: 240px;
  }
  
  .area-master .rectangle-163 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1210px;
    width: 240px;
  }
  
  .area-master .rectangle-164 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1265px;
    width: 240px;
  }
  
  .area-master .rectangle-165 {
    background-color: #ffffff;
    border-radius: 2px;
    height: 50px;
    left: 361px;
    position: absolute;
    top: 1320px;
    width: 240px;
  }
  
  .area-master .header-tabel {
    height: 70px;
    left: 0;
    position: absolute;
    top: 0;
    width: 1857px;
  }
  
  .area-master .rectangle-166 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 0;
    position: absolute;
    top: 0;
    width: 131px;
  }
  
  .area-master .rectangle-167 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 136px;
    position: absolute;
    top: 0;
    width: 220px;
  }
  
  .area-master .rectangle-168 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 793px;
    position: absolute;
    top: 0;
    width: 225px;
  }
  
  .area-master .rectangle-169 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 606px;
    position: absolute;
    top: 0;
    width: 182px;
  }
  
  .area-master .rectangle-170 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1677px;
    position: absolute;
    top: 0;
    width: 180px;
  }
  
  .area-master .rectangle-171 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1340px;
    position: absolute;
    top: 0;
    width: 332px;
  }
  
  .area-master .rectangle-172 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 1023px;
    position: absolute;
    top: 0;
    width: 312px;
  }
  
  .area-master .rectangle-173 {
    background-color: #069dae;
    border-radius: 2px;
    height: 70px;
    left: 361px;
    position: absolute;
    top: 0;
    width: 240px;
  }
  
  .area-master .text-wrapper-22 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 419px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-23 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 48px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-24 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 147px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-25 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 639px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-26 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 1126px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-27 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 1426px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-28 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 823px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  
  .area-master .text-wrapper-29 {
    color: #ffffff;
    font-family: "Roboto-Medium", Helvetica;
    font-size: 24px;
    font-weight: 500;
    left: 1724px;
    letter-spacing: 0;
    line-height: normal;
    position: absolute;
    text-align: center;
    top: 20px;
    white-space: nowrap;
  }
  `, "",{"version":3,"sources":["webpack://./src/style/area.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;IACd,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yDAAmD;IACnD,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,aAAa;EACf;;EAEA;IACE,aAAa;IACb,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB","sourcesContent":[".area-master {\n    background-color: #e9f2f7e3;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .area-master .div {\n    background-color: #e9f2f7e3;\n    border: 1px none;\n    height: 1080px;\n    overflow: hidden;\n    position: relative;\n    width: 1920px;\n  }\n  \n  .area-master .overlap {\n    background-color: #ffffff;\n    border: 1px solid;\n    border-color: #d9d9d9;\n    height: 102px;\n    left: -1px;\n    position: absolute;\n    top: -1px;\n    width: 1922px;\n  }\n  \n  .area-master .header-DATA {\n    color: #000000;\n    font-family: \"Red Hat Display-Bold\", Helvetica;\n    font-size: 24px;\n    font-weight: 700;\n    left: 111px;\n    letter-spacing: 0.24px;\n    line-height: normal;\n    position: absolute;\n    top: 33px;\n  }\n  \n  .area-master .logo-SIVINA {\n    background-image: url(../assets/images/bg/logo.png);\n    background-size: 100% 100%;\n    height: 60px;\n    left: 31px;\n    position: absolute;\n    top: 20px;\n    width: 60px;\n  }\n  \n  .area-master .action-project {\n    color: #000000;\n    font-family: \"Montserrat-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 1329px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 35px;\n  }\n  \n  .area-master .action-dashboard {\n    color: #000000;\n    font-family: \"Montserrat-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 1650px;\n    letter-spacing: 0.48px;\n    line-height: normal;\n    position: absolute;\n    top: 35px;\n  }\n  \n  .area-master .profile-icon {\n    background-color: #49bc92;\n    border-radius: 25px;\n    height: 50px;\n    left: 1840px;\n    position: absolute;\n    top: 25px;\n    width: 50px;\n  }\n  \n  .area-master .s {\n    height: 18px;\n    left: 19px;\n    position: absolute;\n    top: 16px;\n    width: 13px;\n  }\n  \n  .area-master .caption-menampilkan {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 813px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 1030px;\n    white-space: nowrap;\n  }\n  \n  .area-master .page {\n    height: 35px;\n    left: 1640px;\n    position: absolute;\n    top: 1027px;\n    width: 257px;\n  }\n  \n  .area-master .text-wrapper {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 45px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-2 {\n    color: #000000;\n    font-family: \"Roboto-SemiBold\", Helvetica;\n    font-size: 24px;\n    font-weight: 600;\n    left: 0;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .area-master .button-next {\n    height: 35px;\n    left: 169px;\n    position: absolute;\n    top: 0;\n    width: 37px;\n  }\n  \n  .area-master .overlap-group {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 35px;\n    position: relative;\n    width: 35px;\n  }\n  \n  .area-master .text-wrapper-3 {\n    color: #ffffff;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-4 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 87px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 4px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-5 {\n    color: #000000;\n    font-family: \"Roboto-Light\", Helvetica;\n    font-size: 24px;\n    font-weight: 300;\n    left: 135px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 3px;\n    white-space: nowrap;\n  }\n  \n  .area-master .button-end {\n    height: 35px;\n    left: 214px;\n    position: absolute;\n    top: 0;\n    width: 37px;\n  }\n  \n  .area-master .text-wrapper-6 {\n    color: #ffffff;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 24px;\n    font-weight: 400;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 2px;\n    white-space: nowrap;\n  }\n  \n  .area-master .vector-stroke {\n    height: 6px;\n    left: 13px;\n    position: absolute;\n    top: 19px;\n    width: 10px;\n  }\n  \n  .area-master .button-add-new {\n    height: 40px;\n    left: 1670px;\n    position: absolute;\n    top: 115px;\n    width: 222px;\n  }\n  \n  .area-master .div-wrapper {\n    background-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 220px;\n  }\n  \n  .area-master .text-wrapper-7 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 40px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-wrapper {\n    height: 40px;\n    left: 1445px;\n    position: absolute;\n    top: 115px;\n    width: 222px;\n  }\n  \n  .area-master .text-wrapper-8 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 23px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-group-wrapper {\n    height: 40px;\n    left: 1220px;\n    position: absolute;\n    top: 115px;\n    width: 222px;\n  }\n  \n  .area-master .text-wrapper-9 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 54px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 8px;\n    white-space: nowrap;\n  }\n  \n  .area-master .action-area-store {\n    height: 40px;\n    left: 499px;\n    position: absolute;\n    top: 115px;\n    width: 323px;\n  }\n  \n  .area-master .overlap-2 {\n    background-color: #ffffff;\n    border: 3px solid;\n    border-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 321px;\n  }\n  \n  .area-master .polygon {\n    height: 13px;\n    left: 291px;\n    position: absolute;\n    top: 10px;\n    width: 15px;\n  }\n  \n  .area-master .text-wrapper-10 {\n    color: #9f9696;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 20px;\n    font-weight: 500;\n    left: 11px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    top: 5px;\n    white-space: nowrap;\n  }\n  \n  .area-master .action-search {\n    height: 40px;\n    left: 32px;\n    position: absolute;\n    top: 115px;\n    width: 464px;\n  }\n  \n  .area-master .overlap-3 {\n    background-color: #ffffff;\n    border: 3px solid;\n    border-color: #069dae;\n    border-radius: 5px;\n    height: 40px;\n    position: relative;\n    width: 462px;\n  }\n  \n  .area-master .union {\n    height: 17px;\n    left: 428px;\n    position: absolute;\n    top: 8px;\n    width: 17px;\n  }\n  \n  .area-master .overlap-4 {\n    height: 840px;\n    left: 31px;\n    position: absolute;\n    top: 170px;\n    width: 1857px;\n  }\n  \n  .area-master .table {\n    height: 840px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 1857px;\n  }\n  \n  .area-master .baris-isi {\n    height: 765px;\n    left: 0;\n    overflow: hidden;\n    overflow-y: scroll;\n    position: absolute;\n    top: 75px;\n    width: 1857px;\n  }\n  \n  .area-master .overlap-5 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 131px;\n  }\n  \n  .area-master .text-wrapper-11 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 59px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-6 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 0;\n    width: 220px;\n  }\n  \n  .area-master .text-wrapper-12 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 54px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-7 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 0;\n    width: 221px;\n  }\n  \n  .area-master .text-wrapper-13 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 66px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-8 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 0;\n    width: 182px;\n  }\n  \n  .area-master .text-wrapper-14 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 44px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .rectangle {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 0;\n    width: 180px;\n  }\n  \n  .area-master .overlap-9 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 0;\n    width: 312px;\n  }\n  \n  .area-master .text-wrapper-15 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 80px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-10 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 0;\n    width: 332px;\n  }\n  \n  .area-master .text-wrapper-16 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 93px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-11 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .area-master .text-wrapper-17 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 57px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-12 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 55px;\n    width: 131px;\n  }\n  \n  .area-master .overlap-13 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 55px;\n    width: 220px;\n  }\n  \n  .area-master .overlap-14 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 55px;\n    width: 221px;\n  }\n  \n  .area-master .overlap-group-2 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 55px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-2 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 55px;\n    width: 180px;\n  }\n  \n  .area-master .overlap-15 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 55px;\n    width: 312px;\n  }\n  \n  .area-master .overlap-16 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 55px;\n    width: 332px;\n  }\n  \n  .area-master .text-wrapper-18 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 130px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-17 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 55px;\n    width: 240px;\n  }\n  \n  .area-master .overlap-18 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 110px;\n    width: 131px;\n  }\n  \n  .area-master .overlap-19 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 110px;\n    width: 220px;\n  }\n  \n  .area-master .overlap-20 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 110px;\n    width: 221px;\n  }\n  \n  .area-master .overlap-21 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 110px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-3 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 110px;\n    width: 180px;\n  }\n  \n  .area-master .overlap-22 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 110px;\n    width: 312px;\n  }\n  \n  .area-master .overlap-23 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 110px;\n    width: 332px;\n  }\n  \n  .area-master .text-wrapper-19 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 83px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .overlap-24 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 110px;\n    width: 240px;\n  }\n  \n  .area-master .overlap-25 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 165px;\n    width: 131px;\n  }\n  \n  .area-master .overlap-26 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 220px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-4 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 275px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-5 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 330px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-6 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 385px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-7 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 440px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-8 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 495px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-9 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 550px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-10 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 605px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-11 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 660px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-12 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 715px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-13 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 770px;\n    width: 131px;\n  }\n  \n  .area-master .overlap-27 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 165px;\n    width: 220px;\n  }\n  \n  .area-master .overlap-28 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 220px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-14 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 275px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-15 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 330px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-16 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 385px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-17 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 440px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-18 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 495px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-19 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 550px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-20 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 605px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-21 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 660px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-22 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 715px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-23 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 770px;\n    width: 220px;\n  }\n  \n  .area-master .overlap-29 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 165px;\n    width: 221px;\n  }\n  \n  .area-master .overlap-30 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 220px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-24 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 275px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-25 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 330px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-26 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 385px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-27 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 440px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-28 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 495px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-29 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 550px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-30 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 605px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-31 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 660px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-32 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 715px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-33 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 770px;\n    width: 221px;\n  }\n  \n  .area-master .overlap-31 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 165px;\n    width: 182px;\n  }\n  \n  .area-master .overlap-32 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 220px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-34 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 275px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-35 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 330px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-36 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 385px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-37 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 440px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-38 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 495px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-39 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 550px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-40 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 605px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-41 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 660px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-42 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 715px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-43 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 770px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-44 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 165px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-45 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 220px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-46 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 275px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-47 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 330px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-48 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 385px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-49 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 440px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-50 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 495px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-51 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 550px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-52 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 605px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-53 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 660px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-54 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 715px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-55 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 770px;\n    width: 180px;\n  }\n  \n  .area-master .overlap-33 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 165px;\n    width: 312px;\n  }\n  \n  .area-master .overlap-34 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 220px;\n    width: 312px;\n  }\n  \n  .area-master .text-wrapper-20 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 70px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 11px;\n    white-space: nowrap;\n  }\n  \n  .area-master .rectangle-56 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 275px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-57 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 330px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-58 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 385px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-59 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 440px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-60 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 495px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-61 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 550px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-62 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 605px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-63 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 660px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-64 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 715px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-65 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 770px;\n    width: 312px;\n  }\n  \n  .area-master .overlap-35 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 165px;\n    width: 332px;\n  }\n  \n  .area-master .overlap-36 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 220px;\n    width: 332px;\n  }\n  \n  .area-master .text-wrapper-21 {\n    color: #000000;\n    font-family: \"Roboto-Regular\", Helvetica;\n    font-size: 22px;\n    font-weight: 400;\n    left: 130px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 16px;\n    white-space: nowrap;\n  }\n  \n  .area-master .rectangle-66 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 275px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-67 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 330px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-68 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 385px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-69 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 440px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-70 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 495px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-71 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 550px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-72 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 605px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-73 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 660px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-74 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 715px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-75 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 770px;\n    width: 332px;\n  }\n  \n  .area-master .overlap-37 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 165px;\n    width: 240px;\n  }\n  \n  .area-master .overlap-38 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 220px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-76 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 275px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-77 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 330px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-78 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 385px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-79 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 440px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-80 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 495px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-81 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 550px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-82 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 605px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-83 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 660px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-84 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 715px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-85 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 770px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-86 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 825px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-87 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 825px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-88 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 825px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-89 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 825px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-90 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 825px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-91 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 825px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-92 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 825px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-93 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 825px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-94 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 880px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-95 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 935px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-96 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 990px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-97 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1045px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-98 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1100px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-99 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1155px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-100 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1210px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-101 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1265px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-102 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 0;\n    position: absolute;\n    top: 1320px;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-103 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 880px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-104 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 935px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-105 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 990px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-106 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1045px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-107 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1100px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-108 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1155px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-109 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1210px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-110 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1265px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-111 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 136px;\n    position: absolute;\n    top: 1320px;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-112 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 880px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-113 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 935px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-114 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 990px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-115 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1045px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-116 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1100px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-117 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1155px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-118 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1210px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-119 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1265px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-120 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 793px;\n    position: absolute;\n    top: 1320px;\n    width: 221px;\n  }\n  \n  .area-master .rectangle-121 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 880px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-122 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 935px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-123 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 990px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-124 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1045px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-125 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1100px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-126 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1155px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-127 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1210px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-128 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1265px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-129 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 606px;\n    position: absolute;\n    top: 1320px;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-130 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 880px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-131 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 935px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-132 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 990px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-133 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1045px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-134 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1100px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-135 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1155px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-136 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1210px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-137 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1265px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-138 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1677px;\n    position: absolute;\n    top: 1320px;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-139 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 880px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-140 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 935px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-141 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 990px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-142 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1045px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-143 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1100px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-144 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1155px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-145 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1210px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-146 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1265px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-147 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1023px;\n    position: absolute;\n    top: 1320px;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-148 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 880px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-149 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 935px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-150 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 990px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-151 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 1045px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-152 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 1100px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-153 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 1155px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-154 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 1210px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-155 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 1265px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-156 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 1340px;\n    position: absolute;\n    top: 1320px;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-157 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 880px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-158 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 935px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-159 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 990px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-160 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1045px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-161 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1100px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-162 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1155px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-163 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1210px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-164 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1265px;\n    width: 240px;\n  }\n  \n  .area-master .rectangle-165 {\n    background-color: #ffffff;\n    border-radius: 2px;\n    height: 50px;\n    left: 361px;\n    position: absolute;\n    top: 1320px;\n    width: 240px;\n  }\n  \n  .area-master .header-tabel {\n    height: 70px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 1857px;\n  }\n  \n  .area-master .rectangle-166 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 131px;\n  }\n  \n  .area-master .rectangle-167 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 136px;\n    position: absolute;\n    top: 0;\n    width: 220px;\n  }\n  \n  .area-master .rectangle-168 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 793px;\n    position: absolute;\n    top: 0;\n    width: 225px;\n  }\n  \n  .area-master .rectangle-169 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 606px;\n    position: absolute;\n    top: 0;\n    width: 182px;\n  }\n  \n  .area-master .rectangle-170 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1677px;\n    position: absolute;\n    top: 0;\n    width: 180px;\n  }\n  \n  .area-master .rectangle-171 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1340px;\n    position: absolute;\n    top: 0;\n    width: 332px;\n  }\n  \n  .area-master .rectangle-172 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 1023px;\n    position: absolute;\n    top: 0;\n    width: 312px;\n  }\n  \n  .area-master .rectangle-173 {\n    background-color: #069dae;\n    border-radius: 2px;\n    height: 70px;\n    left: 361px;\n    position: absolute;\n    top: 0;\n    width: 240px;\n  }\n  \n  .area-master .text-wrapper-22 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 419px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-23 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 48px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-24 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 147px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-25 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 639px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-26 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 1126px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-27 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 1426px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-28 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 823px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  \n  .area-master .text-wrapper-29 {\n    color: #ffffff;\n    font-family: \"Roboto-Medium\", Helvetica;\n    font-size: 24px;\n    font-weight: 500;\n    left: 1724px;\n    letter-spacing: 0;\n    line-height: normal;\n    position: absolute;\n    text-align: center;\n    top: 20px;\n    white-space: nowrap;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
